import accountDashboard from './accountDashboard';
import chartSettingsModal from './chartSettingsModal';
import chartWidget from './chartWidget';
import common from './common';
import dataWindow from './dataWindow';
import domPanel from './domPanel';
import indicatorModal from './indicatorModal';
import leftSideDrawingToolbar from './leftSideDrawingToolbar';
import loadSavedLayoutModal from './loadSavedLayoutModal';
import objectTree from './objectTree';
import orderForm from './orderForm';
import rightSideToolbar from './rightSideToolbar';
import symbolInfo from './symbolInfo';
import symbolSearchModal from './symbolSearchModal';
import topNavbar from './topNavbar';
import variables from './variables';
import watchlist from './watchlist';

const customCss = `
${variables}
${common}
${watchlist}
${leftSideDrawingToolbar}
${chartWidget}
${accountDashboard}
${orderForm}
${domPanel}
${symbolInfo}
${dataWindow}
${objectTree}
${chartSettingsModal}
${indicatorModal}
${loadSavedLayoutModal}
${symbolSearchModal}
${topNavbar}
${rightSideToolbar}
`;

const customCssBlob = new Blob([customCss], {
  type: 'text/css',
});

const customCssBlobUrl = URL.createObjectURL(customCssBlob);

export default customCssBlobUrl;
